// 모바일(/m/**) 쓰기 화면 공용 fetch 헬퍼 — Alpine magic $mapi (Phase G, 2026-09-18)
//
// 모바일 폼은 데스크톱 JSON API(/work/api, /suit/api, /client/api)를 그대로 호출한다. 인터셉터는 경로 기반이라
// 세션 만료 시 데스크톱 /login 으로 302 가 오므로(res.redirected) 여기서 /m/login 으로 돌린다 — mobileNoteSheet.js 선례.
// 중복 로그인은 fetch 에 401 JSON(code: DUPLICATE_LOGIN)만 오고 감지 상태를 바꾸지 않는다(서비스 원칙 3)
// → 이동하지 않고 서버 메시지를 그대로 throw 해 호출부 토스트로 알린다(다음 페이지 이동에서 세션 종료 모달).
//
// 사용: const json = await this.$mapi(url, { method: 'POST', body: {...} });  // body 는 객체(JSON 직렬화)
//   - 성공: 응답 json 전체 반환(ApiResponse — 데이터는 json.data)
//   - 실패: Error(message) throw — 비2xx 또는 success=false
//   - 세션 만료: /m/login 이동 후 Error('SESSION') throw(호출부는 e.message === 'SESSION' 이면 토스트 생략)
export default async function mapi(url, opts = {}) {
    const init = {
        method: opts.method || 'GET',
        headers: { 'X-Requested-With': 'fetch' }
    };
    if (opts.body !== undefined) {
        init.headers['Content-Type'] = 'application/json';
        init.body = JSON.stringify(opts.body);
    }
    const res = await fetch(url, init);
    if (res.redirected) {
        window.location.href = '/m/login';
        throw new Error('SESSION');
    }
    let json = null;
    try { json = await res.json(); } catch (e) { json = null; }
    if (res.status === 401 && !(json && json.code === 'DUPLICATE_LOGIN')) {
        window.location.href = '/m/login';
        throw new Error('SESSION');
    }
    if (!res.ok || !json || !json.success) {
        throw new Error((json && json.message) || ('HTTP ' + res.status));
    }
    return json;
}
